/*
 *  This code was originally in bm-experimental. It is intentionally written in JavaScript,
 *  as it was originally intended to be common code which could be shared with the Front End Framework.
 */
// REVIEW - KMS - if this is not currently used, should we just remove it?
(function (angular) {
    'use strict';
    // TODO: move to module 'fef' before submitting to FEF.
    angular.module('bmpDefaultTranslateConfig', []).config(['$translateProvider',
        function($translateProvider) {
            $translateProvider.useMissingTranslationHandler('bmpLogAndReturnBlankMissingTranslationHandler');
            $translateProvider.useSanitizeValueStrategy('escaped');
        }
    ]);
}(window.angular));
